export default {
  "titles": {
    "editProfile": "Edit profile"
  },
  "detail": {
    "email": "E-Mail (username)",
    "permits": "Permissions",
    "categories": "Categories",
    "isAdmin": "Administrator - All permissions",
    "editData": "Edit data",
    "linkToWearable": "Sleepiness bracelets",
    "resetPassword": "Reestablish password",
    "linkToFitbit": "Connect Fitbit",
    "unLinkToFitbit": "Disconnect Fitbit",
    "fitbitState": "Fitbit state",
    "connect": "Connected",
    "disconnect": "Disconnected",
    "tours": "Tours",
    "resetTours": "Reestablish tours"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/user_profile/index.js